module.exports = __webpack_public_path__ + "resource/img/image009.4c4ba443.png";